<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
    left
    fixed
    @input="updateDrawer(!! $event)"
  >
    <!-- logo -->
    <v-list two-line dark class="py-0 ch-list--primary">
      <v-list-item href="/">
        <v-list-item-action><v-icon></v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <v-img height="24" contain position="left center" eager :src="logo"></v-img>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- primary menu items -->
    <v-list dense class="pt-0 ch-list--primary">
      <v-list-item href="/">
        <v-list-item-action></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="(item, i) in menuItems"
        :key="i"
        :href="item.url"
      >
        <v-list-item-action><!-- <v-icon></v-icon> --></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title :class="item.highlight ? 'accent--text' : ''">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="/video/">
        <v-list-item-action><v-icon></v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Video</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="/audio/">
        <v-list-item-action><v-icon></v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Audio</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <!-- secondary menu items -->
    <v-list dense class="text--upper ch-list--secondary">
      <v-list-item v-for="(item, i) in secondaryItems" :key="i" :href="item.url">
        <v-list-item-action><v-icon></v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle :class="item.highlight ? 'accent--text ' : ''">{{ item.title }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <!-- social menu items -->
    <v-list dense class="text--upper g-list--social">
      <v-list-item href="https://twitter.com/conhome" target="_blank" rel="noopener">
        <v-list-item-action><v-icon small color="light-blue accent-3">mdi-twitter</v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle>Twitter</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="https://www.facebook.com/conservativehome" target="_blank" rel="noopener">
        <v-list-item-action><v-icon small color="blue accent-2">mdi-facebook</v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle>Facebook</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="https://www.youtube.com/channel/UCbxXu42P7hiExin_nfG5XQw" target="_blank" rel="noopener">
        <v-list-item-action><v-icon small color="red accent-4">mdi-youtube</v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle>YouTube</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="/feed" target="_blank" rel="noopener">
        <v-list-item-action><v-icon small color="amber accent-3">mdi-rss</v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle>RSS</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'NavDrawer',

    props: {
      menuItems: {
        type: Array,
        default: () => ([])
      },
      secondaryItems: {
        type: Array,
        default: () => ([])
      },
      tertiaryItems: {},
      value: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      finalLogo: require('@/assets/conhome-logo-new-final.svg'),
      pinkLogo: require('@/assets/conhome-full-logo-pink.svg'),
      fullLogo: require('@/assets/conhome-full-logo-fixed.svg'),
      houseLogo: require('@/assets/conhome-house-logo-fixed.svg')
    }),

    computed: {
      drawer: {
        get() {
          return this.value
        },
        set(val) {
          return val
        }
      },
      logo() {
        return this.finalLogo //this.$vuetify.breakpoint.xs ? this.houseLogo : this.fulllogo
      }
    },

    methods: {
      updateDrawer(state) {
        this.$emit('updated', state)
      }
    }
  }
</script>